import Model from 'src/models/model'
import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { isOutOfStock } from 'src/services/inventory/sales-restrictions'
import { toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item variation availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

export function useIsItemVariationAvailable () {
  const currentSite = Model.configuration?.currentSite

  function isItemVariationAvailable (itemVariation, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    const itemVariationValue = toValue(itemVariation)

    if (_.isNil(itemVariationValue)) return false

    const salesChannelValue = toValue(salesChannel)
    const orderItemValue = toValue(orderItem)

    // The Item Variation must be active (not archived) to be presented
    if (itemVariationValue.archivable && !itemVariationValue.isActive) return false

    // The Item Variation must be available on the current Sales Channel
    if (!itemVariationValue.isSalesChannelEnabled(salesChannelValue)) return false

    // If the Sales Channel is private, the Item Variation is available, regardless of
    // Inventory or Sales Toggle (the Item Variation may be shown without being selectable)
    if (_.includes(SALES_CHANNEL_TYPES.PRIVATE, salesChannelValue)) return true

    // TODO OOS INDY-6757 Should this also check salesDisabled on the Item?
    // Item Variations may be purchased directly via Vouchers or Item Packages, which would bypass Item availability
    if (itemVariationValue.salesDisabled) return false

    if (!_.isNil(orderItemValue?.itemOrderItem?.item) && currentSite?.activeInventoryStrategy?.excludeOutOfStockItemsForKioskAndConsumer) {
      if (isOutOfStock(itemVariationValue, { item: orderItemValue?.itemOrderItem?.item, itemOrderItem: orderItemValue?.itemOrderItem, orderItem: orderItemValue })) return false
    }

    return true
  }

  return {
    isItemVariationAvailable
  }
}
